import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

export const ERROR_KEY = 'errors';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(err: Error | HttpErrorResponse) {
    const e = err instanceof HttpErrorResponse ? err.error : err;
    if (!e) {
      console.error('Unknown error');
      return;
    }
    const errors = localStorage.getItem(ERROR_KEY);
    let errorList = new Array(1);
    if (errors && errors.length > 0) {
      errorList = JSON.parse(errors);
    }
    if (e?.stack) {
      errorList.push({ errorName: e?.name, message: e?.message, stack: e?.stack });
    } else {
      errorList.push(e);
    }

    try {
      localStorage.setItem(ERROR_KEY, JSON.stringify(errorList));
    } catch (e) {
      console.error('Could not save errors in localStorage - ' + e);
    }

    if (!(err instanceof HttpErrorResponse)) {
      console.error(err);
    }
  }
}
